import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { Column, ColumnKeys } from './grid-config';
import { EcsAssignment } from '@nirvana/shared/dtos/types/policies/common';
import { SetFiltersRequest } from '../../../../../../../../grid/types/common';
import { convertRegexFilterToStartsWithFilter } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/filters-converters';

export class GzEcsAssignmentDataProvider extends GzPolicyUiSettingsGridDataProvider<Column, ColumnKeys, EcsAssignment> {
  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    // convert regex to startsWith
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.NAME);
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.IP);
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.CUSTOM_HOST_NAME);
    return;
  }
}
